window.addEventListener('SITE_START', () => {
  const currentPage = document.querySelector('#award.wrapper');
  if (!currentPage) return;

  awardPageTabControl();

  function awardPageTabControl() {

    const layout = document.querySelector('.left-tab-layout');
    const tab = document.querySelectorAll('.left-tab-list .__item[data-tab]');

    const scrollToTab = () => {
      if (window.lenis) {
        // Lenis 사용 중
        window.lenis.scrollTo(layout, {
          duration: 1.2,
          lock: true,
          //offset: -80, // 고정 헤더 보정
          onComplete: () => {
            ScrollTrigger.refresh();
            header?.classList.add('--hide');
          }
        });
      } else {
        // Lenis 미사용 시 fallback (GSAP ScrollToPlugin)
        gsap.to(window, {
          scrollTo: layout,
          duration: 1.2,
          ease: Quart.easeOut,
          onComplete: () => {
            ScrollTrigger.refresh();
            header?.classList.add('--hide');
          }
        });
      }
    };

    tab.forEach(item => {
      item.addEventListener('click', e => {
        // 스크롤 이동
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollToTab();
          });
        });
      });
    });
  };
});